module.exports = __webpack_public_path__ + "media/images/sidbar-b88b689edb647f2e0bdfdb0847bcd75f.jpg";